let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kNFvF"), load("ffQaD"), load("kvRbA"), load("kVX56"), load("76n7a"), load("l253H"), load("8Zw7g")]).then(() => parcelRequire('bNzBR'));